module.exports = __webpack_public_path__ + "static/quiz_stage_6_bg-f1a7d1d30be9a3353db69c706924f11a.svg";